import { fullCapabilitiesSupportedBrowsers } from './fullCapabilitiesSupportedBrowsers';

export const showBrowserRuntimeWarning = (): boolean =>
	!fullCapabilitiesSupportedBrowsers.test(navigator.userAgent);
